import(/* webpackMode: "eager" */ "/root/repo/src/app/poweron-pro/layout.tsx");
